import { processPayment } from '../utils';

export default processPayment('/mifinity/deposit/process', {
  amount: 'required',
  sessionId: 'required',
  userId: 'required',
  merchantId: 'required'
});